import {createRoot} from "react-dom/client"
import {Amplify} from "aws-amplify"
import AWS_CONFIG from "./aws/config"
import "./i18n/i18n"
import AppProviders from "./AppProviders"
import App from "./App"
import DisableConsoleLog from "./tools/DisableConsoleLog"
import {BrowserRouter} from "react-router-dom"

DisableConsoleLog()
Amplify.configure(AWS_CONFIG)

createRoot(document.getElementById("root")).render(
    <>
    <BrowserRouter>
        <AppProviders>
            <App/>
        </AppProviders>
    </BrowserRouter>
    </>
)